import { isSameDay } from 'date-fns'

export interface NormalizedRangeDateChange {
  startDate: Date | null
  endDate: Date | null
  shouldClose: boolean
}

export function normalizeRangeDateChange(value: Date | [Date | null, Date | null] | null): NormalizedRangeDateChange | null {
  if (!Array.isArray(value)) {
    return null
  }

  const [nextStartDate, nextEndDate] = value

  if (nextStartDate && nextEndDate && isSameDay(nextStartDate, nextEndDate)) {
    return {
      startDate: nextStartDate,
      endDate: null,
      shouldClose: false,
    }
  }

  return {
    startDate: nextStartDate,
    endDate: nextEndDate,
    shouldClose: Boolean(nextStartDate && nextEndDate),
  }
}
